import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog"; 
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button"; 

export default function UserClaimForm({
  isOpen,
  onClose,
  onSubmit,
  initialData,
}) {
  const [formData, setFormData] = useState({
    userId: 0,
    groupId: 0,
  });

  useEffect(() => {
    if (initialData) {
      setFormData({userId: initialData.userId, groupId: initialData.groups[0]?.id||0});
    } else {
      setFormData({
        userId: 0,
        groupId: 0,
      });
    }
  }, [initialData]);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formData.groupId) {
      newErrors.groupId = "Boş bırakılamaz.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
   
  const handleDropdownChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
 
    e.preventDefault();
    if (validateForm()) {
      let data = {userId: formData.userId,
        groupId: [formData.groupId]}
      onSubmit(data);
    }
  };
  const footer = () => {
    return (
      <div className=" flex  w-full m-0">
        <div className="p-d-flex p-jc-end col-12 ">
          <Button
            className="w-full "
            label="Güncelle"
            icon="pi pi-check"
            severity="success"
            outlined
            onClick={handleSubmit}
          />
        </div>
      </div>
    );
  };
  return (
    <Dialog
      className="max-w-full w-11 md:w-8  xl:w-6  "
      visible={isOpen}
      footer={footer()}
      onHide={onClose}
      header={ "Kullanıcı Yetkisi"}
    >
      <form className="  grid mt-3  ">
        <div className={`col-12 md:col-8  `}>
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Yetki</span>
            <Dropdown
              id="groupId"
              name="groupId"
              value={formData.groupId}
              options={[
                { label: "Sistem Admin", value: 1 },
                { label: "Cari Admin", value: 2 },
                { label: "Cari Kullanıcı", value: 3 },
              ]}
              onChange={(e) => handleDropdownChange("groupId", e.value)}
            />
           
            {errors.groupId && (
              <span className="p-inputgroup-addon max-w-max">
                <small className="p-error">{errors.groupId}</small>
              </span>
            )}
          </div>
        </div>
        <div className={`col-12 md:col-4 flex  align-items-center  `}>
          <div className="  flex-1 w-12 flex justify-content-center flex-wrap    ">
            <span>Yetki Seçiniz</span>
          </div>
        </div>
      </form>
    </Dialog>
  );
}
